import { Outlet } from "react-router-dom";

import { FilterEmploymentStatusProvider } from "./filter-employment-status/filter-employment-status.context";
import './employment-status.scss';

export function EmploymentStatus() {
  return (
    <div id="EmploymentStatus" className="employment-status">
       <FilterEmploymentStatusProvider>
        <Outlet />
      </FilterEmploymentStatusProvider>
    </div>
  );
}

export default EmploymentStatus;
